<template>
  <gj-tree-select
      v-bind="$attrs"
      v-on="$listeners"
      :data="active ? activeProductCategoryTree : productCategoryTree"
      select-all-node
      :show-checkbox="multiple"
      placeholder="品类"
      :showScroll="true"
  ></gj-tree-select>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "gj-category-select",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters(['activeProductCategoryTree', 'productCategoryTree']),
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tree{
    margin-right: 4px;
  }
</style>

